import React from 'react';
import { useTheme } from '../../hooks/useTheme';
export interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}
export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  size?: 'sm' | 'md';
  variant?: 'default' | 'accent';
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  size = 'md',
  variant = 'default',
  className = ''
}: TabsProps) {
  const {
    theme
  } = useTheme();
  const isLight = theme === 'light';
  const isSmall = size === 'sm';
  return <div className={`inline-flex items-center overflow-hidden rounded-lg flex-shrink-0 ${className}`} style={{
    border: `1px solid ${isLight ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.08)'}`,
    backgroundColor: isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.04)',
    height: isSmall ? 24 : 28
  }} role="tablist" data-id="element-1126">
      {tabs.map((tab, index) => {
      const isActive = activeTab === tab.id;
      return <button key={tab.id} role="tab" aria-selected={isActive} disabled={tab.disabled} onClick={() => !tab.disabled && onChange(tab.id)} className={`
              flex items-center justify-center gap-1.5 font-medium transition-all h-full
              ${isSmall ? 'px-2.5 text-[11px]' : 'px-3 text-xs'}
              ${tab.disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
            `} style={{
        backgroundColor: isActive ? 'rgba(236,72,153,0.15)' : 'transparent',
        color: isActive ? '#EC4899' : isLight ? '#475569' : '#94a3b8',
        borderRight: index < tabs.length - 1 ? `1px solid ${isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.06)'}` : 'none'
      }} onMouseEnter={e => {
        if (!isActive && !tab.disabled) {
          e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.06)';
          e.currentTarget.style.color = isLight ? '#1e293b' : '#fff';
        }
      }} onMouseLeave={e => {
        if (!isActive && !tab.disabled) {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = isLight ? '#475569' : '#94a3b8';
        }
      }} data-id="element-1127">
            {tab.icon && <span className={`flex-shrink-0 ${isActive ? 'text-[#EC4899]' : ''}`} data-id="element-1128">
                {tab.icon}
              </span>}
            {tab.label}
          </button>;
    })}
    </div>;
}